import { useQueryClient } from "@tanstack/react-query";
import React, { useState } from "react";
import YesNoModal from "../../../../../components/YesNoModal";
import { Analysis } from "../../../@types";
import { useLocalSampleSummaryParams, useReanalyze } from "../../../hooks";
import { sampleReportKeys } from "../../../queryKeys";
import { Error } from "../../common/dynamicanalysis";
import { ANALYSIS_MAP } from "./consts";

type Props = {
  analysis: Analysis;
  errors: Array<string>;
  isRetryable: boolean;
  status: string;
};

const ErrorContainer: React.FC<Props> = ({
  analysis,
  errors,
  isRetryable,
  status
}) => {
  const queryClient = useQueryClient();
  const { hash = "", sourceId, relationshipId } = useLocalSampleSummaryParams();
  const { mutate: reanalyze } = useReanalyze();

  const [show, setShow] = useState<boolean>(false);

  const showModal = () => {
    setShow(true);
  };

  const hideModal = () => {
    setShow(false);
  };

  const handleResubmit = () => {
    reanalyze(
      {
        samples: [
          {
            hash_value: hash,
            source_id: sourceId,
            relationship_id: relationshipId
          }
        ],
        integrations: [analysis]
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: sampleReportKeys.generalInfo(hash, analysis)
          });
        }
      }
    );
    hideModal();
  };

  const analysisLabel = ANALYSIS_MAP[analysis];

  return (
    <>
      <Error
        errors={errors}
        status={status}
        analysis={analysis}
        isRetryable={isRetryable}
        onResubmit={showModal}
      />
      <YesNoModal
        id="resubmit-confirm"
        title={`Resubmit to ${analysisLabel}`}
        show={show}
        onClickNo={hideModal}
        onClickYes={handleResubmit}
        onHide={hideModal}
        buttonLabels={{ yes: "Resubmit", no: "Cancel" }}
      >
        <>
          <p>This will resubmit sample to {analysisLabel} integration only.</p>
          <p>Do you wish to process?</p>
        </>
      </YesNoModal>
    </>
  );
};

export default ErrorContainer;
